import React from 'react';
import { useIntl } from 'react-intl';

import styles from './PoweredByFooter.module.less';

export const PoweredByFooter: React.FC = () => {
  const intl = useIntl();

  return (
    <div className={styles.footer}>
      <span className={styles.text}>
        {intl.formatMessage({ id: 'footer.poweredBy' })}
      </span>
      <span role="img" aria-label="Firefish" className={styles.logoContainer}>
        <span className={styles.logoText} />
        <span className={styles.logoSymbol} />
      </span>
    </div>
  );
};
